import { render, staticRenderFns } from "./assistentIa.vue?vue&type=template&id=4ad4e842"
import script from "./assistentIa.vue?vue&type=script&lang=js"
export * from "./assistentIa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports